import { SectionPaper } from "@/components/AcquireBook/SectionPaper";
import { type Control, Controller, type FieldValues } from "react-hook-form";
import type { FieldPath } from "react-hook-form/dist/types";
import type { ReactElement } from "react";

interface IProps<T extends FieldValues> {
  control: Control<T> | undefined;
  name: FieldPath<T>;
  children: React.ReactNode;
}

/**
 * SectionPaperコンポーネントのコントローラー対応版
 * コントローラーの詳細はReact-Hook-Formのドキュメントを参照
 * https://www.react-hook-form.com/api/usecontroller/controller/
 * @param props
 */
const CSectionPaper = <T extends FieldValues>(
  props: IProps<T>
): ReactElement => {
  const { name, control, children } = props;

  return (
    <Controller
      name={name}
      control={control}
      render={({ fieldState: { error } }) => {
        return (
          <SectionPaper
            error={Boolean(error)}
            helperText={error?.message ?? error?.root?.message}
          >
            {children}
          </SectionPaper>
        );
      }}
    />
  );
};

export { CSectionPaper };
